import { render, staticRenderFns } from "./SessionAboutEnd.template.vue?vue&type=template&id=a2c46c8e&scoped=true&"
var script = {}
import style0 from "./SessionAboutEnd.template.vue?vue&type=style&index=0&id=a2c46c8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c46c8e",
  null
  
)

export default component.exports